import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { BroadcastsSpaceDispatchProps, BroadcastsSpaceOwnProps, BroadcastsSpaceStateProps, SiteBroadcastsSpace } from './SiteBroadcastsSpace';

const mapStateToProps: MapStateToProps<BroadcastsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<BroadcastsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedSiteBroadcastsSpace: React.ComponentClass<BroadcastsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(SiteBroadcastsSpace);
